import { CommunicationMergeTag, UnlayerMergeTags } from './communication-template.models';

/** Slug used as the key in Unlayer's nested merge-tag map. */
function slug(text: string): string {
  return text.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

/**
 * Folds the flat API catalogue into Unlayer's nested `mergeTags` shape so the editor renders grouped
 * sub-menus, carrying each tag's `sample` through for the in-canvas preview.
 *
 * Shared by the organisation-side template manager and the SB-15889 library curation screen: the
 * catalogue is global (the endpoint ignores its organisationId segment), so both editors offer the same
 * tags and there is no reason for two copies of the shaping.
 */
export function buildUnlayerMergeTags(tags: CommunicationMergeTag[]): UnlayerMergeTags {
  const grouped: UnlayerMergeTags = {};

  for (const tag of tags) {
    const groupKey = slug(tag.group) || 'general';
    const group = (grouped[groupKey] ??= { name: tag.group, mergeTags: {} });
    group.mergeTags![slug(tag.name)] = {
      name: tag.name,
      value: tag.value,
      ...(tag.sample ? { sample: tag.sample } : {})
    };
  }

  return grouped;
}

/** The subject as it is stored: runs of whitespace collapsed to one space, and trimmed. */
export function normaliseSubject(subject: string | null | undefined): string {
  return (subject ?? '').replace(/\s+/g, ' ').trim();
}
